module.exports = __webpack_public_path__ + "img/absorbente3.7644f29e.jpg";